import type { CompararSimulacaoDialogProps } from "./types-comparar-simulacao-dialog";
import { useCompararSimulacaoDialog } from "./use-comparar-simulacao-dialog";
import { CompararSimulacaoDialogView } from "./view-comparar-simulacao-dialog";

/** "Comparar" (HU 2221): Atual × Simulado por obra, filtrável por tipo. */
export function CompararSimulacaoDialog(props: CompararSimulacaoDialogProps) {
  const vm = useCompararSimulacaoDialog(props);

  return <CompararSimulacaoDialogView {...vm} />;
}

export type * from "./types-comparar-simulacao-dialog";
